import { type PostExternalAddressPayload, queryClient } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

import { postExternalAddress } from '../data-access/api';

/**
 * @returns addRecipient mutation object
 */
export const useWalletWithdrawAddRecipientMutation = () =>
	useMutation({
		mutationFn: (payload: PostExternalAddressPayload) => postExternalAddress(payload),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['recipients', 'cc2'] })
	});
